/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.7.1.0 (NJsonSchema v9.6.0.0) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';

import { HydrogenAppConfigService } from '../host.config.service';


export const API_BASE_URL = new InjectionToken('API_BASE_URL');

@Injectable()
export class DeviceMetaDataInfoApiClient {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configSvc: HydrogenAppConfigService,@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = configSvc.config.serviceUrl.devicemetadata;
    }

    getDeviceModels(sortCriteria: string, page: number, pagesize: number): Observable<DeviceModel[]> {
        let url_ = this.baseUrl + "/api/devicemetadata/GetDeviceModels?";
        if (sortCriteria !== undefined)
            url_ += "SortCriteria=" + encodeURIComponent("" + sortCriteria) + "&";
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetDeviceModels(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDeviceModels(response_);
                } catch (e) {
                    return <Observable<DeviceModel[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeviceModel[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDeviceModels(response: Response): Observable<DeviceModel[]> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DeviceModel.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeviceModel[]>(<any>null);
    }

    getDeviceModelByName(modelName: string): Observable<DeviceModel> {
        let url_ = this.baseUrl + "/api/devicemetadata/GetDeviceModelByName?";
        if (modelName === undefined)
            throw new Error("The parameter 'modelName' must be defined.");
        else
            url_ += "modelName=" + encodeURIComponent("" + modelName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetDeviceModelByName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDeviceModelByName(response_);
                } catch (e) {
                    return <Observable<DeviceModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeviceModel>><any>Observable.throw(response_);
        });
    }

    protected processGetDeviceModelByName(response: Response): Observable<DeviceModel> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DeviceModel.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeviceModel>(<any>null);
    }

    getDeviceReports(modelType: string, page: number, pagesize: number): Observable<DeviceReports[]> {
        let url_ = this.baseUrl + "/api/DeviceReports/GetDeviceReports?";
        if (modelType === undefined)
            throw new Error("The parameter 'modelType' must be defined.");
        else
            url_ += "modelType=" + encodeURIComponent("" + modelType) + "&";
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pagesize !== undefined)
            url_ += "pagesize=" + encodeURIComponent("" + pagesize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetDeviceReports(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDeviceReports(response_);
                } catch (e) {
                    return <Observable<DeviceReports[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeviceReports[]>><any>Observable.throw(response_);
        });
    }

    protected processGetDeviceReports(response: Response): Observable<DeviceReports[]> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DeviceReports.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeviceReports[]>(<any>null);
    }

    getDeviceModelByID(modelType: string, viewType: string): Observable<DeviceViewModel> {
        let url_ = this.baseUrl + "/api/devicemetadata/GetDeviceModelByID?";
        if (modelType === undefined)
            throw new Error("The parameter 'modelType' must be defined.");
        else
            url_ += "modelType=" + encodeURIComponent("" + modelType) + "&";
        if (viewType === undefined)
            throw new Error("The parameter 'viewType' must be defined.");
        else
            url_ += "viewType=" + encodeURIComponent("" + viewType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetDeviceModelByID(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDeviceModelByID(response_);
                } catch (e) {
                    return <Observable<DeviceViewModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<DeviceViewModel>><any>Observable.throw(response_);
        });
    }

    protected processGetDeviceModelByID(response: Response): Observable<DeviceViewModel> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DeviceViewModel.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DeviceViewModel>(<any>null);
    }

    getTimezones(): Observable<Timezones> {
        let url_ = this.baseUrl + "/api/devicemetadata/GetTimezones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetTimezones(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTimezones(response_);
                } catch (e) {
                    return <Observable<Timezones>><any>Observable.throw(e);
                }
            } else
                return <Observable<Timezones>><any>Observable.throw(response_);
        });
    }

    protected processGetTimezones(response: Response): Observable<Timezones> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Timezones.fromJS(resultData200) : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<Timezones>(<any>null);
    }
}

export class DeviceModel implements IDeviceModel {
    id?: string;
    modelType?: string;
    supportedActions?: string[];
    supportedStatusFields?: string[];
    supportedFileTypes?: string[];
    components?: { [key: string]: string; };
    maxLicenseCount?: number;
    slots: number;

    constructor(data?: IDeviceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.modelType = data["modelType"] !== undefined ? data["modelType"] : <any>null;
            if (data["supportedActions"] && data["supportedActions"].constructor === Array) {
                this.supportedActions = [];
                for (let item of data["supportedActions"])
                    this.supportedActions.push(item);
            }
            if (data["supportedStatusFields"] && data["supportedStatusFields"].constructor === Array) {
                this.supportedStatusFields = [];
                for (let item of data["supportedStatusFields"])
                    this.supportedStatusFields.push(item);
            }
            if (data["supportedFileTypes"] && data["supportedFileTypes"].constructor === Array) {
                this.supportedFileTypes = [];
                for (let item of data["supportedFileTypes"])
                    this.supportedFileTypes.push(item);
            }
            if (data["Components"]) {
                this.components = {};
                for (let key in data["Components"]) {
                    if (data["Components"].hasOwnProperty(key))
                        this.components[key] = data["Components"][key] !== undefined ? data["Components"][key] : <any>null;
                }
            }
            this.maxLicenseCount = data["MaxLicenseCount"] !== undefined ? data["MaxLicenseCount"] : <any>null;
            this.slots = data["Slots"] !== undefined ? data["Slots"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceModel {
        let result = new DeviceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["modelType"] = this.modelType !== undefined ? this.modelType : <any>null;
        if (this.supportedActions && this.supportedActions.constructor === Array) {
            data["supportedActions"] = [];
            for (let item of this.supportedActions)
                data["supportedActions"].push(item);
        }
        if (this.supportedStatusFields && this.supportedStatusFields.constructor === Array) {
            data["supportedStatusFields"] = [];
            for (let item of this.supportedStatusFields)
                data["supportedStatusFields"].push(item);
        }
        if (this.supportedFileTypes && this.supportedFileTypes.constructor === Array) {
            data["supportedFileTypes"] = [];
            for (let item of this.supportedFileTypes)
                data["supportedFileTypes"].push(item);
        }
        if (this.components) {
            data["Components"] = {};
            for (let key in this.components) {
                if (this.components.hasOwnProperty(key))
                    data["Components"][key] = this.components[key] !== undefined ? this.components[key] : <any>null;
            }
        }
        data["MaxLicenseCount"] = this.maxLicenseCount !== undefined ? this.maxLicenseCount : <any>null;
        data["Slots"] = this.slots !== undefined ? this.slots : <any>null;
        return data;
    }
}

export interface IDeviceModel {
    id?: string;
    modelType?: string;
    supportedActions?: string[];
    supportedStatusFields?: string[];
    supportedFileTypes?: string[];
    components?: { [key: string]: string; };
    maxLicenseCount?: number;
    slots: number;
}

export class CustomError implements ICustomError {
    severity: SeverityEnum;
    statusCode: HttpStatusCode;
    correlationId?: string;
    message?: string;
    exceptionType?: string;

    constructor(data?: ICustomError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.severity = data["Severity"] !== undefined ? data["Severity"] : <any>null;
            this.statusCode = data["StatusCode"] !== undefined ? data["StatusCode"] : <any>null;
            this.correlationId = data["CorrelationId"] !== undefined ? data["CorrelationId"] : <any>null;
            this.message = data["Message"] !== undefined ? data["Message"] : <any>null;
            this.exceptionType = data["ExceptionType"] !== undefined ? data["ExceptionType"] : <any>null;
        }
    }

    static fromJS(data: any): CustomError {
        let result = new CustomError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Severity"] = this.severity !== undefined ? this.severity : <any>null;
        data["StatusCode"] = this.statusCode !== undefined ? this.statusCode : <any>null;
        data["CorrelationId"] = this.correlationId !== undefined ? this.correlationId : <any>null;
        data["Message"] = this.message !== undefined ? this.message : <any>null;
        data["ExceptionType"] = this.exceptionType !== undefined ? this.exceptionType : <any>null;
        return data;
    }
}

export interface ICustomError {
    severity: SeverityEnum;
    statusCode: HttpStatusCode;
    correlationId?: string;
    message?: string;
    exceptionType?: string;
}

export enum SeverityEnum {
    None = 0,
    Warning = 1,
    Error = 2,
    Exception = 3,
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultipleChoices = 300,
    Ambiguous = 300,
    MovedPermanently = 301,
    Moved = 301,
    Found = 302,
    Redirect = 302,
    SeeOther = 303,
    RedirectMethod = 303,
    NotModified = 304,
    UseProxy = 305,
    Unused = 306,
    TemporaryRedirect = 307,
    RedirectKeepVerb = 307,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    NotAcceptable = 406,
    ProxyAuthenticationRequired = 407,
    RequestTimeout = 408,
    Conflict = 409,
    Gone = 410,
    LengthRequired = 411,
    PreconditionFailed = 412,
    RequestEntityTooLarge = 413,
    RequestUriTooLong = 414,
    UnsupportedMediaType = 415,
    RequestedRangeNotSatisfiable = 416,
    ExpectationFailed = 417,
    UpgradeRequired = 426,
    InternalServerError = 500,
    NotImplemented = 501,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    HttpVersionNotSupported = 505,
}

export class DeviceReports implements IDeviceReports {
    id: string;
    reportType?: string;
    modelType?: string;
    url?: string;
    reportId: string;

    constructor(data?: IDeviceReports) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.reportType = data["reportType"] !== undefined ? data["reportType"] : <any>null;
            this.modelType = data["modelType"] !== undefined ? data["modelType"] : <any>null;
            this.url = data["url"] !== undefined ? data["url"] : <any>null;
            this.reportId = data["reportId"] !== undefined ? data["reportId"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceReports {
        let result = new DeviceReports();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["reportType"] = this.reportType !== undefined ? this.reportType : <any>null;
        data["modelType"] = this.modelType !== undefined ? this.modelType : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
        return data;
    }
}

export interface IDeviceReports {
    id: string;
    reportType?: string;
    modelType?: string;
    url?: string;
    reportId: string;
}

export class DeviceViewModel implements IDeviceViewModel {
    id?: string;
    settingsViewModel?: DeviceCategoryModel[];
    statusViewModel?: DeviceCategoryModel[];

    constructor(data?: IDeviceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            if (data["SettingsViewModel"] && data["SettingsViewModel"].constructor === Array) {
                this.settingsViewModel = [];
                for (let item of data["SettingsViewModel"])
                    this.settingsViewModel.push(DeviceCategoryModel.fromJS(item));
            }
            if (data["StatusViewModel"] && data["StatusViewModel"].constructor === Array) {
                this.statusViewModel = [];
                for (let item of data["StatusViewModel"])
                    this.statusViewModel.push(DeviceCategoryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceViewModel {
        let result = new DeviceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (this.settingsViewModel && this.settingsViewModel.constructor === Array) {
            data["SettingsViewModel"] = [];
            for (let item of this.settingsViewModel)
                data["SettingsViewModel"].push(item.toJSON());
        }
        if (this.statusViewModel && this.statusViewModel.constructor === Array) {
            data["StatusViewModel"] = [];
            for (let item of this.statusViewModel)
                data["StatusViewModel"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeviceViewModel {
    id?: string;
    settingsViewModel?: DeviceCategoryModel[];
    statusViewModel?: DeviceCategoryModel[];
}

export class DeviceCategoryModel implements IDeviceCategoryModel {
    id?: string;
    groupid?: string;
    name?: string;
    selected?: boolean;
    visible?: boolean;
    policy?: boolean;
    layout?: DeviceCategoryLayoutModel;
    settings?: DeviceControlModel[];
    categories?: DeviceCategoryModel[];
    grouping?: DeviceControlModel[];

    constructor(data?: IDeviceCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.groupid = data["groupid"] !== undefined ? data["groupid"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.selected = data["selected"] !== undefined ? data["selected"] : <any>null;
            this.visible = data["visible"] !== undefined ? data["visible"] : <any>null;
            this.policy = data["policy"] !== undefined ? data["policy"] : <any>null;
            this.layout = data["layout"] ? DeviceCategoryLayoutModel.fromJS(data["layout"]) : <any>null;
            if (data["settings"] && data["settings"].constructor === Array) {
                this.settings = [];
                for (let item of data["settings"])
                    this.settings.push(DeviceControlModel.fromJS(item));
            }
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [];
                for (let item of data["categories"])
                    this.categories.push(DeviceCategoryModel.fromJS(item));
            }
            if (data["grouping"] && data["grouping"].constructor === Array) {
                this.grouping = [];
                for (let item of data["grouping"])
                    this.grouping.push(DeviceControlModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceCategoryModel {
        let result = new DeviceCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["groupid"] = this.groupid !== undefined ? this.groupid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        data["visible"] = this.visible !== undefined ? this.visible : <any>null;
        data["policy"] = this.policy !== undefined ? this.policy : <any>null;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>null;
        if (this.settings && this.settings.constructor === Array) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (this.grouping && this.grouping.constructor === Array) {
            data["grouping"] = [];
            for (let item of this.grouping)
                data["grouping"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeviceCategoryModel {
    id?: string;
    groupid?: string;
    name?: string;
    selected?: boolean;
    visible?: boolean;
    policy?: boolean;
    layout?: DeviceCategoryLayoutModel;
    settings?: DeviceControlModel[];
    categories?: DeviceCategoryModel[];
    grouping?: DeviceControlModel[];
}

export class DeviceCategoryLayoutModel implements IDeviceCategoryLayoutModel {
    type?: string;
    data?: any[];

    constructor(data?: IDeviceCategoryLayoutModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(item);
            }
        }
    }

    static fromJS(data: any): DeviceCategoryLayoutModel {
        let result = new DeviceCategoryLayoutModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }
}

export interface IDeviceCategoryLayoutModel {
    type?: string;
    data?: any[];
}

export class DeviceControlModel implements IDeviceControlModel {
    id?: string;
    label?: string;
    value?: any;
    type: DeviceControlType;
    hardPath?: string;
    softPath?: string;
    required?: boolean;
    mask?: string;
    placeholder?: string;
    alert?: boolean;
    locked?: boolean;
    options?: any[];
    collection?: any;
    apply?: boolean;
    conflicted?: boolean;
    inherited?: boolean;
    policy?: boolean;
    selectable?: boolean;
    visible?: boolean;
    suffix?: string;
    validator?: string;
    default?: any;

    constructor(data?: IDeviceControlModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.label = data["label"] !== undefined ? data["label"] : <any>null;
            this.value = data["value"] !== undefined ? data["value"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.hardPath = data["hardPath"] !== undefined ? data["hardPath"] : <any>null;
            this.softPath = data["softPath"] !== undefined ? data["softPath"] : <any>null;
            this.required = data["required"] !== undefined ? data["required"] : <any>null;
            this.mask = data["mask"] !== undefined ? data["mask"] : <any>null;
            this.placeholder = data["placeholder"] !== undefined ? data["placeholder"] : <any>null;
            this.alert = data["alert"] !== undefined ? data["alert"] : <any>null;
            this.locked = data["locked"] !== undefined ? data["locked"] : <any>null;
            if (data["options"] && data["options"].constructor === Array) {
                this.options = [];
                for (let item of data["options"])
                    this.options.push(item);
            }
            this.collection = data["collection"] !== undefined ? data["collection"] : <any>null;
            this.apply = data["apply"] !== undefined ? data["apply"] : <any>null;
            this.conflicted = data["conflicted"] !== undefined ? data["conflicted"] : <any>null;
            this.inherited = data["inherited"] !== undefined ? data["inherited"] : <any>null;
            this.policy = data["policy"] !== undefined ? data["policy"] : <any>null;
            this.selectable = data["selectable"] !== undefined ? data["selectable"] : <any>null;
            this.visible = data["visible"] !== undefined ? data["visible"] : <any>null;
            this.suffix = data["suffix"] !== undefined ? data["suffix"] : <any>null;
            this.validator = data["validator"] !== undefined ? data["validator"] : <any>null;
            this.default = data["default"] !== undefined ? data["default"] : <any>null;
        }
    }

    static fromJS(data: any): DeviceControlModel {
        let result = new DeviceControlModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["hardPath"] = this.hardPath !== undefined ? this.hardPath : <any>null;
        data["softPath"] = this.softPath !== undefined ? this.softPath : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["mask"] = this.mask !== undefined ? this.mask : <any>null;
        data["placeholder"] = this.placeholder !== undefined ? this.placeholder : <any>null;
        data["alert"] = this.alert !== undefined ? this.alert : <any>null;
        data["locked"] = this.locked !== undefined ? this.locked : <any>null;
        if (this.options && this.options.constructor === Array) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["collection"] = this.collection !== undefined ? this.collection : <any>null;
        data["apply"] = this.apply !== undefined ? this.apply : <any>null;
        data["conflicted"] = this.conflicted !== undefined ? this.conflicted : <any>null;
        data["inherited"] = this.inherited !== undefined ? this.inherited : <any>null;
        data["policy"] = this.policy !== undefined ? this.policy : <any>null;
        data["selectable"] = this.selectable !== undefined ? this.selectable : <any>null;
        data["visible"] = this.visible !== undefined ? this.visible : <any>null;
        data["suffix"] = this.suffix !== undefined ? this.suffix : <any>null;
        data["validator"] = this.validator !== undefined ? this.validator : <any>null;
        data["default"] = this.default !== undefined ? this.default : <any>null;
        return data;
    }
}

export interface IDeviceControlModel {
    id?: string;
    label?: string;
    value?: any;
    type: DeviceControlType;
    hardPath?: string;
    softPath?: string;
    required?: boolean;
    mask?: string;
    placeholder?: string;
    alert?: boolean;
    locked?: boolean;
    options?: any[];
    collection?: any;
    apply?: boolean;
    conflicted?: boolean;
    inherited?: boolean;
    policy?: boolean;
    selectable?: boolean;
    visible?: boolean;
    suffix?: string;
    validator?: string;
    default?: any;
}

export enum DeviceControlType {
    Button = 0,
    ButtonCrud = 1,
    CheckBox = 2,
    CheckBoxList = 3,
    ComboBox = 4,
    Default = 5,
    DialogBox = 6,
    FileUpload = 7,
    Grid = 8,
    InputSwitch = 9,
    Password = 10,
    RadioButton = 11,
    TextBox = 12,
    Time = 13,
}

export class Timezones implements ITimezones {
    id?: string;
    label?: string;
    options?: Option[];

    constructor(data?: ITimezones) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.label = data["label"] !== undefined ? data["label"] : <any>null;
            if (data["options"] && data["options"].constructor === Array) {
                this.options = [];
                for (let item of data["options"])
                    this.options.push(Option.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Timezones {
        let result = new Timezones();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        if (this.options && this.options.constructor === Array) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimezones {
    id?: string;
    label?: string;
    options?: Option[];
}

export class Option implements IOption {
    value?: string;
    abbr?: string;
    offset: number;
    isdst: boolean;
    text?: string;
    utc?: string[];

    constructor(data?: IOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"] !== undefined ? data["value"] : <any>null;
            this.abbr = data["abbr"] !== undefined ? data["abbr"] : <any>null;
            this.offset = data["offset"] !== undefined ? data["offset"] : <any>null;
            this.isdst = data["isdst"] !== undefined ? data["isdst"] : <any>null;
            this.text = data["text"] !== undefined ? data["text"] : <any>null;
            if (data["utc"] && data["utc"].constructor === Array) {
                this.utc = [];
                for (let item of data["utc"])
                    this.utc.push(item);
            }
        }
    }

    static fromJS(data: any): Option {
        let result = new Option();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["abbr"] = this.abbr !== undefined ? this.abbr : <any>null;
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["isdst"] = this.isdst !== undefined ? this.isdst : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        if (this.utc && this.utc.constructor === Array) {
            data["utc"] = [];
            for (let item of this.utc)
                data["utc"].push(item);
        }
        return data;
    }
}

export interface IOption {
    value?: string;
    abbr?: string;
    offset: number;
    isdst: boolean;
    text?: string;
    utc?: string[];
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return Observable.throw(result);
    else
        return Observable.throw(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        let reader = new FileReader();
        reader.onload = function () {
            observer.next(this.result);
            observer.complete();
        }
        reader.readAsText(blob);
    });
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/Crestron.HydrogenAPI.DeviceMetaDataInfoClient.ts